// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zBaseBonusResponseDto = z.object({
    bonusAmount: z.coerce.bigint(),
    bonusCount: z.int(),
    bonusTotalCount: z.int(),
    totalWin: z.coerce.bigint(),
    isActive: z.optional(z.boolean())
});

export const zBaseBetResponseDto = z.object({
    username: z.string().min(1),
    token: z.string().min(1),
    balance: z.coerce.bigint(),
    betId: z.string().min(1),
    gameRoundId: z.string().min(1),
    baseBonusResponseDto: z.optional(zBaseBonusResponseDto)
});

export const zBetTowersCommand = z.object({
    token: z.string().min(1),
    pickedBrick: z.int(),
    gameRoundId: z.string().min(1)
});

export const zTowersResultCacheDto = z.object({
    isBrick: z.optional(z.boolean()),
    isMine: z.optional(z.boolean()),
    isPicked: z.optional(z.boolean()),
    row: z.optional(z.int()),
    column: z.optional(z.int())
});

export const zBetTowersResponseDto = z.object({
    username: z.string().min(1),
    token: z.string().min(1),
    balance: z.coerce.bigint(),
    betId: z.string().min(1),
    gameRoundId: z.string().min(1),
    baseBonusResponseDto: z.optional(zBaseBonusResponseDto),
    towersResults: z.optional(z.union([
        z.array(zTowersResultCacheDto),
        z.null()
    ])),
    isEnd: z.optional(z.boolean()),
    isWin: z.optional(z.union([
        z.boolean(),
        z.null()
    ])),
    winId: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    win: z.optional(z.coerce.bigint())
});

export const zCashoutTowersCommand = z.object({
    token: z.string().min(1),
    gameRoundId: z.string().min(1)
});

export const zFastBetTowersCommand = z.object({
    amount: z.coerce.bigint().gte(BigInt(1)),
    token: z.string().min(1),
    pattern: z.int().gte(0).lte(4),
    pickedBricks: z.array(z.int()),
    gameRoundId: z.string().min(1)
});

export const zSessionsCacheDto = z.object({
    balance: z.optional(z.coerce.bigint()),
    username: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    token: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    gameRoundId: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    gameCode: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    rtp: z.optional(z.number()),
    minBet: z.optional(z.coerce.bigint()),
    maxBet: z.optional(z.coerce.bigint()),
    maxWin: z.optional(z.coerce.bigint()),
    playerFreeGameId: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    active: z.optional(z.boolean())
});

export const zStartTowersCommand = z.object({
    amount: z.coerce.bigint().gte(BigInt(1)),
    token: z.string().min(1),
    pattern: z.int().gte(0).lte(4),
    gameRoundId: z.string().min(1)
});

export const zTowersCashoutResponseDto = z.object({
    username: z.string().min(1),
    token: z.string().min(1),
    balance: z.coerce.bigint(),
    betId: z.string().min(1),
    gameRoundId: z.string().min(1),
    baseBonusResponseDto: z.optional(zBaseBonusResponseDto),
    win: z.coerce.bigint(),
    winId: z.string().min(1),
    towersResults: z.optional(z.union([
        z.array(zTowersResultCacheDto),
        z.null()
    ]))
});

export const zTowersDetailDto = z.object({
    status: z.string().min(1),
    token: z.string().min(1),
    userName: z.string().min(1),
    balance: z.coerce.bigint(),
    defaultBet: z.number(),
    minBet: z.number(),
    maxBet: z.number(),
    maxWin: z.number(),
    bets: z.array(z.number()),
    betStep: z.number(),
    currency: z.string().min(1),
    currencyType: z.string().min(1),
    gameStatus: z.string().min(1),
    avatarId: z.int(),
    gameRoundId: z.string().min(1),
    coeficient: z.int(),
    currencyExchange: z.number(),
    gameRoundStart: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    gameRoundEnd: z.optional(z.union([
        z.iso.datetime(),
        z.null()
    ])),
    baseBonusResponseDto: z.optional(zBaseBonusResponseDto),
    pattern: z.optional(z.union([
        z.int(),
        z.null()
    ])),
    betAmount: z.optional(z.union([
        z.number(),
        z.null()
    ])),
    towersResults: z.array(zTowersResultCacheDto)
});

export const zUnit = z.record(z.string(), z.never());

export const zHeadHealthCheckData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zGetApiCommonShutdownData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Success
 */
export const zGetApiCommonShutdownResponse = z.string();

export const zPostApiCommonShutdownData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Success
 */
export const zPostApiCommonShutdownResponse = zUnit;

export const zHeadApiCommonHealthCheckData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zGetApiGameInitData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        Token: z.string(),
        VisitorId: z.string()
    })
});

/**
 * Success
 */
export const zGetApiGameInitResponse = zTowersDetailDto;

export const zPostApiGameStartData = z.object({
    body: z.optional(zStartTowersCommand),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Success
 */
export const zPostApiGameStartResponse = zBaseBetResponseDto;

export const zPostApiGameBetData = z.object({
    body: z.optional(zBetTowersCommand),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Success
 */
export const zPostApiGameBetResponse = zBetTowersResponseDto;

export const zPostApiGameFastBetData = z.object({
    body: z.optional(zFastBetTowersCommand),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Success
 */
export const zPostApiGameFastBetResponse = zTowersCashoutResponseDto;

export const zPostApiGameCashoutData = z.object({
    body: z.optional(zCashoutTowersCommand),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Success
 */
export const zPostApiGameCashoutResponse = zTowersCashoutResponseDto;

export const zGetApiGameCheckData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        Token: z.string()
    })
});

/**
 * Success
 */
export const zGetApiGameCheckResponse = zSessionsCacheDto;

export const zHeadApiGameHealthCheckData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});